var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fae59d22e59d306f3fea9d1d4f1b77fff99f8b43"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["cloudbase-dapp@delta-labs"]={id:"fae59d22e59d306f3fea9d1d4f1b77fff99f8b43"};
      